export default __webpack_public_path__ + "static/media/daily_goal_set_now.a338b0c6.svg";